import { Button } from '@mantine/core'
import { createContext, useContext, useEffect, type ReactNode } from 'react'

const FabVisibilityContext = createContext<(hidden: boolean) => void>(() => {})

/** Wraps the shell (`Layout.tsx`) so a page below can hide the FAB via [useHideFab]. */
export const FabVisibilityProvider = FabVisibilityContext.Provider

/**
 * Hides the shared FAB while [hidden] is true, for a page whose own bottom action row would otherwise sit under or
 * collide with it — the Food log's selection toolbar (`FoodLogPage.tsx`'s sticky footer) is the only one today.
 * Restores the FAB on unmount, so leaving the page (or ending the selection) always brings it back.
 */
export function useHideFab(hidden: boolean) {
  const setHidden = useContext(FabVisibilityContext)
  useEffect(() => {
    setHidden(hidden)
    return () => setHidden(false)
  }, [hidden, setHidden])
}

/**
 * The FAB above the bottom nav (owner decision, §12 #4 — mirrors the phone's "+" moving off the nav bar into a FAB):
 * always the medium extended size, since M3's small FAB is "no longer recommended". Collapsing to an icon-only FAB
 * on scroll (as the phone's extended FABs will) is not done here.
 * ponytail: fixed extended size, add scroll-collapse if a long list makes it block content.
 */
export function Fab(props: { label: string; icon: ReactNode; onClick: () => void }) {
  return (
    <Button className="mt-fab" radius="xl" size="lg" leftSection={props.icon} onClick={props.onClick}>
      {props.label}
    </Button>
  )
}
